export default [
  {
    name: '小小不背接入第三方 SDK 目录',
    path: '/sdklist',
    component: () => import('@/views/priviacy/KidsSdk.vue'),
  },
  {
    name: '小小不背的应用权限说明',
    path: '/permission/explain',
    component: () => import('@/views/priviacy/KidsPermissionExplain.vue'),
  },
  {
    name: '小小不背的个人信息收集清单',
    path: '/people/collect-info-list',
    component: () => import('@/views/priviacy/KidsCollectInfoList.vue'),
  },
  {
    name: '小小不背隐私协议简明版',
    path: '/privacy-concise',
    component: () => import('@/views/priviacy/KidsPrivacyConcise.vue'),
  },
  {
    name: '小小不背服务使用条款',
    path: '/agreement',
    component: () => import('@/views/priviacy/KidsAgreement.vue'),
  },
  {
    name: '小小不背隐私协议',
    path: '/privacy',
    component: () => import('@/views/priviacy/KidsPriviacy.vue'),
  },
  {
    name: '儿童个人信息保护规则',
    path: '/kids/children-information-rules',
    component: () => import('@/views/priviacy/KidsChildrenInformationRules.vue'),
  },
];
